import { type ApiResponse } from '@webapp/core/interfaces/api/ApiResponse'
import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type AssignedCreditCardConstructor } from '@webapp/modules/expense/entities/AssignedCreditCard'
import { type ICreditCardRepository } from '../../../business-logic/interfaces/ICreditCardRepository'
import { type AssignedCreditCardApiModel } from '../../api-models/AssignedCreditCardApiModel'
import { mapAssignedCreditCardApiModel } from '../../mappers/mapAssignedCreditCardApiModel'

interface Dependency {
  httpClient: IHttpClient
}

export class CreditCardRepository implements ICreditCardRepository {
  constructor(private readonly deps: Dependency) {}

  async listAssigned(userId: number): Promise<AssignedCreditCardConstructor[]> {
    try {
      const res = await this.deps.httpClient.get<
        ApiResponse<AssignedCreditCardApiModel[]>
      >(`/api/v3/users/${userId}/creditcards/`, {
        params: { page_size: 999 },
      })

      return res.data.data.map(mapAssignedCreditCardApiModel)
    } catch (err) {
      throwRepoErrorFromApiV3Error(err)
    }
  }
}
